import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DeleteModal from "../../DeleteModal";
import { useDispatch } from "react-redux";
import {
  discardPodcast,
  episodeStatusChanged,
  getEpiosde,
  publishPodcast,
} from "../../../features/slices/poadcast";
import { useSelector } from "react-redux";
import TableSkeleton from "../../TableSkeleton";
import CommonPagination from "../../CommonPagination";
import moment from "moment";
import { toastService } from "../../../utils/toastify";
import ExportToExcel from "../../ExportToExcel";

const initalState = {
  currentPage: 1,
  searchQuery: "",
  fromDate: "",
  toDate: "",
  timeframe: "",
  status: "",
  deleteModal: false,
  id: "",
  filterStatus: "",
};
const EpisodeList = () => {
  const [iState, setUpdateState] = useState(initalState);
  const {
    searchQuery,
    fromDate,
    toDate,
    timeframe,
    status,
    deleteModal,
    id,
    filterStatus,
  } = iState;
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { episode, loading } = useSelector((state) => state?.podcast);
  const [page, setPage] = useState(1);
  const poadcastEpisodeRef = useRef();
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const handleShowDeleteModal = (id) => {
    console.log({ id });

    setUpdateState((prev) => ({
      ...prev,
      deleteModal: true,
      id: id,
    }));
  };
  console.log({ id });

  const hanldeClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deleteModal: false,
    }));
  };
  const handleDelete = () => {
    dispatch(episodeStatusChanged({ id: id, status: "DELETED" })).then(
      (res) => {
        if (res?.payload?.code == 200) {
          dispatch(getEpiosde({ podcastId: state?.podcastId }));
          hanldeClose();
          toastService.success("Episode deleted successfully");
        } else {
          toastService.error(res?.payload?.message);
          console.log(res);
        }
      }
    );
  };
  useEffect(() => {
    if (!state?.add) {
      dispatch(getEpiosde({ podcastId: state?.podcastId, page }));
    }
  }, [page]);
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getEpiosde({
            podcastId: state?.podcastId,
            search: searchQuery?.trim(),
            status: filterStatus,
          })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleStatus = (e, id) => {
    const value = e.target.checked ? "ACTIVE" : "INACTIVE";
    const data = { id: id, status: value, page };
    dispatch(episodeStatusChanged(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getEpiosde({ podcastId: state?.podcastId })).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status updated successfully");
            setUpdateState((prev) => ({
              ...prev,
              status: "",
            }));
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  const handleReset = () => {
    setUpdateState(initalState);
    dispatch(getEpiosde({ podcastId: state?.podcastId, page }));
  };
  const handleTimeFrame = (e) => {
    const queryParams = {
      timeframe: e.target.value,
      podcastId: state?.podcastId,
    };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    dispatch(getEpiosde(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      search: searchQuery?.trim(),
      status: status,
      podcastId: state?.podcastId,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }
    dispatch(getEpiosde(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   searchQuery: "",
        //   fromDate: "",
        //   toDate: "",
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleFilter = (e) => {
    const status = e.target.value;
    setUpdateState((prev) => ({
      ...prev,
      filterStatus: status,
    }));
    dispatch(
      getEpiosde({
        status: status,
        search: searchQuery?.trim(),
        podcastId: state?.podcastId,
      })
    );
  };
  const handleSavePodcast = () => {
    dispatch(publishPodcast({ podcastId: state?.podcastId })).then((res) => {
      if (res?.payload?.code === 200) {
        toastService.success("Podcast publish successfully");
        dispatch(getEpiosde({ podcastId: state?.podcastId }));
      } else {
        toastService.error(res?.payload?.message);
        console.log({ res });
      }
    });
  };
  const handleDiscardPodcast = () => {
    dispatch(discardPodcast({ podcastId: state?.podcastId })).then((res) => {
      if (res?.payload?.code === 200) {
        toastService.success("Podcast discard successfully");
        dispatch(getEpiosde({ podcastId: state?.podcastId }));
      } else {
        toastService.error(res?.payload?.message);
        console.log({ res });
      }
    });
  };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox justify-content-between mt-2">
            <figcaption className="ml-4">
              <h5>Episode Management</h5>
            </figcaption>
            <Link
              to={"/podcast/addEpisode"}
              className="TitleLink"
              state={{
                podcastId: state?.podcastId,
                redirect: "/podcast/EpisodeList",
              }}
            >
              <i className="fa-solid fa-plus" /> Add New Episode
            </Link>
          </div>

          <div className="FilterArea">
            <div className="FilterLeft">
              <div className="form-group">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  disabled={timeframe}
                  name="fromDate"
                  onChange={(e) => handleSearch(e)}
                />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="toDate"
                  value={toDate}
                  disabled={timeframe}
                  onChange={(e) => handleSearch(e)}
                />
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <button className="Button" onClick={handleSubmit}>
                  Apply
                </button>
              </div>
              <div className="form-group">
                <label>Timeframe</label>
                <select
                  className="form-control customSelect"
                  name="timeframe"
                  value={timeframe}
                  disabled={fromDate || toDate}
                  onChange={(e) => handleTimeFrame(e)}
                >
                  <option value="" hidden>
                    Select
                  </option>
                  <option value="Today">Today</option>
                  <option value="Week">This Week</option>
                  <option value="Month">This Month</option>
                </select>
              </div>
            </div>
          </div>
          <div className="Small-Wrapper">
            <div className="NewFilter">
              <div className="SearchBox">
                <input
                  type="search"
                  className="SearchInput"
                  placeholder="Search here by ID, Name, or Others"
                  name="searchQuery"
                  value={searchQuery}
                  onChange={(e) => handleSearch(e)}
                />
                <span>
                  <i className="fa fa-search" />
                </span>
              </div>
              <div className="Actions">
                <div
                  className="form-group"
                  style={{
                    textAlign: "center",
                  }}
                >
                  <select
                    className="form-control FilterStatus"
                    name="status"
                    value={status}
                    onChange={(e) => handleFilter(e)}
                  >
                    <option value="" hidden>
                      Filter by Status
                    </option>
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>
                <button className="Button Cancel" onClick={handleReset}>
                  <i className="fa fa-refresh" />
                </button>
                <ExportToExcel
                  ref={poadcastEpisodeRef}
                  fileName="poadcastEpisode"
                />
              </div>
            </div>
            <div className="TableList">
              <table className="table-hover" style={{ width: "150%" }}>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Episode Name</th>
                    <th>Episode Id</th>
                    {/* <th>Episode No.</th> */}
                    <th>Host Name</th>
                    <th>Uploaded On</th>
                    <th>No. of Reach</th>
                    <th>No. of Downloads</th>
                    {/* <th>Avg. & No. of Ratings</th> */}
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <TableSkeleton
                      length={episode?.result?.[0]?.paginationData?.length}
                    />
                  ) : (
                    episode?.result?.[0]?.paginationData.map((res, i) => {
                      return (
                        <tr key={res?._id}>
                          <td>{i + 1}</td>
                          <td>{res?.episodName}</td>
                          <td>{res?.episod_number}</td>
                          {/* <td>01</td> */}
                          <td>{res?.hostName}</td>
                          <td>{moment(res?.createdAt).format("DD/MM/YYYY")}</td>
                          <td>{res?.totalReach}</td>
                          <td>{res?.totalDownload}</td>
                          {/* <td>
                              <a href="broadcast-ratings.html" class="LinkDirect">
                                  4.5 (300)
                              </a>
                          </td> */}
                          <td>
                            <span
                              className={`${
                                res?.status == "ACTIVE" ? "Green" : "Red"
                              }`}
                            >
                              {res?.status == "ACTIVE"
                                ? "Available"
                                : "Blocked"}
                            </span>
                          </td>
                          <td>
                            <div className="Actions">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={res?.status == "ACTIVE"}
                                  name="status"
                                  onChange={(e) => handleStatus(e, res?._id)}
                                />
                                <span className="slider" />
                              </label>
                              <Link
                                to={"/podcast/episodeDetails"}
                                className="Eyes"
                                state={res}
                              >
                                <i className="fa-regular fa-eye" />
                              </Link>
                              <Link
                                to={"/podcast/editDetailEpisode"}
                                className="Edit"
                                state={{
                                  ...res,
                                  redirect: "/podcast/EpisodeList",
                                }}
                              >
                                <i className="fa-regular fa-pen-to-square" />
                              </Link>
                              <a
                                className="Delete"
                                onClick={() => handleShowDeleteModal(res?._id)}
                              >
                                <i className="fa-regular fa-trash-can" />
                              </a>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <div className="Pagination">
              {episode?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <>
                  <p>
                    Showing {(page - 1) * 10 + 1} to{" "}
                    {episode?.result?.[0]?.paginationData?.length +
                      (page - 1) * 10}{" "}
                    of {episode?.result?.[0]?.totalCount?.[0]?.count} results
                  </p>
                  <div className="PaginationRight">
                    <CommonPagination
                      activePage={page}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        episode?.result?.[0]?.totalCount?.[0]?.count || 0
                      }
                      pageRangeDisplayed={4}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                </>
              )}
            </div>
            <button
              className="Button Discard"
              onClick={handleDiscardPodcast}
              disabled={!state?.podcastId}
            >
              Discard
            </button>
            <button
              className="Button"
              onClick={handleSavePodcast}
              disabled={!state?.podcastId}
            >
              Save and Publish
            </button>
          </div>
        </div>
      </div>
      {deleteModal && (
        <DeleteModal
          hanldeClose={hanldeClose}
          statement={"Episode "}
          handleDelete={handleDelete}
        />
      )}
    </>
  );
};

export default EpisodeList;
